var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"component-layer"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"close iconfont icon_cancle_round",on:{"click":_vm.close}}),_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }